import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import MutualFundCalculator from './calculators/MutualFundCalculator';
import HomeEmiCalculator from './calculators/HomeEmiCalculator';
import FDCalculator from './calculators/FDCalculator';
import HraCalculator from './calculators/HraCalculator';
import NPSCalculator from './calculators/NPSCalculator';
import PersonalEmiCalculator from './calculators/PersonalEmiCalculator';

const Calculator: React.FC = () => {
    const location = useLocation();

    const [activeComponent, setActiveComponent] = React.useState<JSX.Element | null>(() => {
        const params = new URLSearchParams(location.search);
        const calculator = params.get('type');

        const calculatorComponents: { [key: string]: JSX.Element } = {
            'mutual-fund': <MutualFundCalculator />,
            'home-emi': <HomeEmiCalculator />,
            'fd': <FDCalculator />,
            'hra': <HraCalculator />,
            'nps': <NPSCalculator />,
            'personal-emi': <PersonalEmiCalculator />
        };

        return calculatorComponents[calculator as string] || <div><h1>Calculator</h1></div>;
    });

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const calculator = params.get('type');

        const calculatorComponents: { [key: string]: JSX.Element } = {
            'mutual-fund': <MutualFundCalculator />,
            'home-emi': <HomeEmiCalculator />,
            'fd': <FDCalculator />,
            'hra': <HraCalculator />,
            'nps': <NPSCalculator />,
            'personal-emi': <PersonalEmiCalculator />
        };

        setActiveComponent(calculatorComponents[calculator as string] || <div><h1>Calculator</h1></div>);
    }, [location.search]);

    return (
        <div className="container">
            <div className="row">
                <div className="col-md-9">
                    {activeComponent}
                </div>
                <div className="col-md-3">
                    <div className="list-group">
                        <h5>Select from below</h5>
                        <button
                            onClick={() => setActiveComponent(<MutualFundCalculator />)}
                            className="list-group-item list-group-item-action">Mutual Fund Calculator
                        </button>
                        <button
                            onClick={() => setActiveComponent(<HomeEmiCalculator />)}
                            className="list-group-item list-group-item-action">Home EMI Calculator
                        </button>
                        <button
                            onClick={() => setActiveComponent(<FDCalculator />)}
                            className="list-group-item list-group-item-action">FD Calculator
                        </button>
                        <button
                            onClick={() => setActiveComponent(<HraCalculator />)}
                            className="list-group-item list-group-item-action">HRA Calculator
                        </button>
                        <button
                            onClick={() => setActiveComponent(<NPSCalculator />)}
                            className="list-group-item list-group-item-action">NPS Calculator
                        </button>
                        <button
                            onClick={() => setActiveComponent(<PersonalEmiCalculator />)}
                            className="list-group-item list-group-item-action">Personal EMI Calculator
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Calculator;